export default [
  {
    leistungstext: "Feuer, Leitungswasser, Rohrbruch/Frost, Sturm/Hagel",
    infoText:
      "Versicherungsschutz besteht, wenn das Gebäude durch eine der genannten Gefahren zerstört oder beschädig wird.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Beitragsfreie Feuer-Rohbauversicherung für 24 Monate",
    infoText: "",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Grobe Fahrlässigkeit (Herbeiführung des Versicherungsfalls)",
    infoText:
      "Es findet keine Kürzung der Leistung aufgrund grober Fahrlässigkeit statt. Dies kann bis zu einer bestimmten Schadenhöhe festgelegt sein. Lassen Sie beispielsweise eine Kerze brennen und das Haus brennt daraufhin ab, würden wir den Schaden dennoch übernehmen.",
    leistungen: ["Schäden bis 1.000 €", "Ja", "Ja"],
  },
  {
    leistungstext: "Aufräumungs- und Abbruchkosten",
    infoText:
      "Kostenübernahme für das Aufräumen nach einem Schaden und, wenn nötig, den Abbruch des Gebäudes - oder Gebäudeteile",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Überspannungsschäden durch Blitz",
    infoText:
      "Kostenübernahme für Schäden, wenn ein Blitz in der Nähe Ihres Grundstückes einschlägt und die Überspannung zu einem Schaden an Ihrer Gebäudeelektronik (z.B. Heizungsanlage) führt.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext:
      "Photovoltaikanlagen und weitere Anlagen zur regenerativen Wärme- oder Stromerzeugung auf/an dem Gebäude",
    infoText:
      "Wir übernehmen die Kosten für die Wiederbeschaffung oder Reparatur, sofern Ihre Photovoltaikanlage durch weitere unvorhersehbare Gefahren zerstört oder beschädigt wird oder abhandengekommen ist. Ergänzend übernehmen wir den entstandenen Ertragsausfall, sofern der Betrieb der Photovoltaikanlage beeinträchtigt wird.",
    leistungen: ["Ja", "Ja", "Ja"],
    photovoltaikErtragsausfallPruefen: true,
  },
  {
    leistungstext: "E-Ladestationen und Anlagen zur regenerativen Wärmeerzeugung auf dem Grundstück",
    infoText: "",
    leistungen: ["1.000 €", "10.000 €", "Ja"],
  },
  {
    leistungstext: "Nässeschäden aufgrund undichter Fugen und Fliesen",
    infoText: "",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Wasserzuleitungsrohre außerhalb des Grundstückes",
    infoText:
      "Leistungen für frostbedingte oder sonstige Bruchschäden an Wasserzuleitungsrohren auch außerhalb Ihres Grundstückes.",
    leistungen: ["Nein", "50.000 €", "Ja"],
  },
  {
    leistungstext: "Ableitungsrohre außerhalb des Gebäudes sowie außerhalb des Grundstückes",
    infoText:
      "Kostenübernahme für Frost- und sonstige Bruchschäden an Ableitungsrohren der Wasserversorgung, auch wenn sie außerhalb des versicherten Grundstücks verlaufen und das beschädigte Rohr der Entsorgung Ihres Gebäudes dient.",
    leistungen: [
      "Nein",
      "15.000 € / 5.000 € ohne Dichtheitsprüfung innerhalb von 10 Jahren vor Schadeneintritt",
      "20.000 €",
    ],
  },
  {
    leistungstext: "Rohrverstopfung",
    infoText: "Mitversichert sind die Kosten, die anfallen um Verstopfungen von Ableitungsrohren zu beseitigen",
    leistungen: ["Nein", "1.000 €", "Ja"],
  },
  {
    leistungstext: "Beseitigung umgestürzter und im Stamm abgeknickter Bäume",
    infoText:
      "Kosten für das Aufräumen und Entfernen von Bäumen, die durch Sturm oder Blitzeinschlag abgeknickt bzw. umgestürzt sind.",
    leistungen: ["Nein", "5.000 €", "Ja"],
  },
  {
    leistungstext: "Mehrkosten infolge Technologiefortschrittes",
    infoText: "",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Regenwassersammelanlagen",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Wiederaufbau an einem anderen Ort nach einem Totalschaden",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
];
